import { Elements } from "@/components/elements";
import Image from "next/image";
import Logo from '@/assets/icons/Logo.svg';
import Logo2 from '@/assets/icons/Logo2.svg';
import Logo3 from '@/assets/icons/Logo3.svg';
import Logo4 from '@/assets/icons/Logo4.svg';
import LogoBlack from '@/assets/icons/LogoBlack.svg';
import LogoBlack2 from '@/assets/icons/LogoBlack2.svg';
import LogoBlack3 from '@/assets/icons/LogoBlack3.svg';
import LogoBlack4 from '@/assets/icons/LogoBlack4.svg';
import LogoWhite from '@/assets/icons/LogoWhite.svg';
import LogoWhite2 from '@/assets/icons/LogoWhite2.svg';
import LogoWhite3 from '@/assets/icons/LogoWhite3.svg';
import LogoWhite4 from '@/assets/icons/LogoWhite4.svg';
import SampleScreen1 from '@/assets/images/screen.webp';
import OgImage from '@/assets/images/og-image.png';
import LogoZip from '@/assets/PB logo.zip';


export const PressKit = () => {
    return (
        <section className="px-4 py-12 sm:px-5 sm:py-14 md:px-10 md:py-16 lg:px-[79px]">
            <div className="mx-auto mb-8 flex w-full max-w-[1200px] flex-col items-center justify-center text-center sm:mb-10">
                <Elements.Title title="Press Kit" type="h2" className="mb-3 text-gray-900 !text-4xl sm:mb-4" />
                <Elements.Description description="Download official company assets, logos, and brand information for media use." type="medium" className="max-w-2xl text-gray-600 md:max-w-none" />
            </div>

            <div className="mx-auto flex max-w-[1200px] flex-col gap-12 md:gap-16 lg:gap-20">

                <div className="grid grid-cols-1 gap-6 md:gap-8 lg:grid-cols-[minmax(0,300px)_1fr] lg:items-start lg:gap-8">
                    <div className="flex w-full max-w-full flex-col gap-2 sm:max-w-md md:items-center md:text-center md:mx-auto md:max-w-none md:gap-4 lg:col-start-1 lg:row-start-1 lg:text-left lg:items-start lg:max-w-none">
                        <Elements.Title title="Logos" type="h3" className="text-gray-900" />
                        <Elements.Description description="Official company logos in multiple formats and color variations." type="medium" className="text-gray-500" />
                        <a
                            href={LogoZip}
                            download="PB-logo.zip"
                            className="btn btn-primary btn-outline hidden w-full md:inline-flex md:w-auto md:self-center lg:w-full lg:self-start"
                        >
                            Download Logo ZIP
                        </a>
                    </div>

                    <div className="grid w-full grid-cols-2 gap-3 sm:grid-cols-3 sm:gap-4 md:grid-cols-4 lg:col-start-2 lg:row-span-2 lg:row-start-1 lg:grid-cols-4">
                        <div className="flex h-[150px] w-full items-center justify-center rounded-2xl bg-gray-100 sm:h-[140px] md:h-[160px]">
                            <Image src={Logo} alt="Company Logo" width={180} height={100} />
                        </div>
                        <div className="flex h-[150px] w-full items-center justify-center rounded-2xl bg-gray-100 sm:h-[140px] md:h-[160px]">
                            <Image src={Logo2} alt="Company Logo" width={150} height={100} />
                        </div>
                        <div className="flex h-[150px] w-full items-center justify-center rounded-2xl bg-gray-100 sm:h-[140px] md:h-[160px]">
                            <Image src={Logo3} alt="Company Logo" width={100} height={100} />
                        </div>
                        <div className="flex h-[150px] w-full items-center justify-center rounded-2xl bg-gray-100 sm:h-[140px] md:h-[160px]">
                            <Image src={Logo4} alt="Company Logo" width={100} height={100} />
                        </div>
                        <div className="flex h-[150px] w-full items-center justify-center rounded-2xl bg-gray-100 sm:h-[140px] md:h-[160px]">
                            <Image src={LogoBlack} alt="Company Logo" width={180} height={100} />
                        </div>
                        <div className="flex h-[150px] w-full items-center justify-center rounded-2xl bg-gray-100 sm:h-[140px] md:h-[160px]">
                            <Image src={LogoBlack2} alt="Company Logo" width={150} height={100} />
                        </div>
                        <div className="flex h-[150px] w-full items-center justify-center rounded-2xl bg-gray-100 sm:h-[140px] md:h-[160px]">
                            <Image src={LogoBlack3} alt="Company Logo" width={100} height={100} />
                        </div>
                        <div className="flex h-[150px] w-full items-center justify-center rounded-2xl bg-gray-100 sm:h-[140px] md:h-[160px]">
                            <Image src={LogoBlack4} alt="Company Logo" width={100} height={100} />
                        </div>
                        <div className="flex h-[150px] w-full items-center justify-center rounded-2xl bg-brand-900 sm:h-[140px] md:h-[160px]">
                            <Image src={LogoWhite} alt="Company Logo" width={180} height={100} />
                        </div>
                        <div className="flex h-[150px] w-full items-center justify-center rounded-2xl bg-brand-900 sm:h-[140px] md:h-[160px]">
                            <Image src={LogoWhite2} alt="Company Logo" width={150} height={100} />
                        </div>
                        <div className="flex h-[150px] w-full items-center justify-center rounded-2xl bg-brand-900 sm:h-[140px] md:h-[160px]">
                            <Image src={LogoWhite3} alt="Company Logo" width={100} height={100} />
                        </div>
                        <div className="flex h-[150px] w-full items-center justify-center rounded-2xl bg-brand-900 sm:h-[140px] md:h-[160px]">
                            <Image src={LogoWhite4} alt="Company Logo" width={100} height={100} />
                        </div>

                    </div>

                    <a
                        href={LogoZip}
                        download="PB-logo.zip"
                        className="btn btn-primary btn-outline w-full md:hidden"
                    >
                        Download Logo ZIP
                    </a>
                    
                </div>

                <div className="flex flex-col gap-6 md:gap-8 lg:flex-row lg:items-start lg:gap-8">
                    <div className="flex w-full max-w-full flex-col gap-2 sm:max-w-md md:items-center md:text-center md:mx-auto md:max-w-none md:gap-4 lg:max-w-[300px] lg:shrink-0 lg:text-left lg:items-start">
                        <Elements.Title title="Our Colors" type="h3" className="text-gray-900" />
                        <Elements.Description description="Official brand colors and usage guidelines" type="medium" className="text-gray-500" />
                    </div>

                    <div className="grid w-full flex-1 grid-cols-2 gap-3 sm:gap-4 md:grid-cols-3 lg:grid-cols-4">
                        <div className="flex min-h-[160px] w-full flex-col items-stretch justify-start overflow-hidden rounded-2xl border border-gray-200 bg-gray-50 md:h-[160px] md:min-h-0">
                            <div className="w-full h-[70px] rounded-t-2xl bg-[#0077DF]">
                            </div>

                            <div className="p-3">
                                <p className="text-lg font-medium text-gray-900 mb-2">Primary Color</p>
                                <div className="flex flex-col  gap-2">
                                    <p className="text-gray-500 text-base">HEX - #0077DF</p>
                                    <p className="text-gray-500 text-base">RGB - 0/119/223</p>
                                </div>
                            </div>
                        </div>
                        <div className="flex min-h-[160px] w-full flex-col items-stretch justify-start overflow-hidden rounded-2xl border border-gray-200 bg-gray-50 md:h-[160px] md:min-h-0">
                            <div className="w-full h-[70px] rounded-t-2xl bg-[#E0EEFB]">
                            </div>

                            <div className="p-3">
                                <p className="text-lg font-medium text-gray-900 mb-2">Primary Color</p>
                                <div className="flex flex-col  gap-1">
                                    <p className="text-gray-500 text-base">HEX - #0077DF</p>
                                    <p className="text-gray-500 text-base">RGB - 0/119/223</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-span-2 flex min-h-[160px] w-full max-w-[calc(50%-0.375rem)] flex-col items-stretch justify-start justify-self-center overflow-hidden rounded-2xl border border-gray-200 bg-gray-50 sm:max-w-[calc(50%-0.5rem)] md:col-span-1 md:h-[160px] md:max-w-none md:min-h-0 md:justify-self-stretch">
                            <div className="w-full h-[70px] rounded-t-2xl bg-[#004785]">
                            </div>

                            <div className="p-3">
                                <p className="text-lg font-medium text-gray-900 mb-2">Primary Color</p>
                                <div className="flex flex-col  gap-1">
                                    <p className="text-gray-500 text-base">HEX - #0077DF</p>
                                    <p className="text-gray-500 text-base">RGB - 0/119/223</p>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                <div className="flex flex-col gap-6 md:gap-8 lg:flex-row lg:items-start lg:gap-8">
                    <div className="flex w-full max-w-full flex-col gap-2 sm:max-w-md md:items-center md:text-center md:mx-auto md:max-w-none md:gap-4 lg:max-w-[300px] lg:shrink-0 lg:text-left lg:items-start">
                        <Elements.Title title="Copy Blurbs" type="h3" className="text-gray-900" />
                        <Elements.Description description="Ready-to-use company descriptions for press, partners, and industry publications." type="medium" className="text-gray-500" />
                    </div>

                    <div className="grid w-full flex-1 grid-cols-1 gap-3 sm:gap-4">
                        <div className="bg-gray-50 w-full border border-gray-200 rounded-2xl flex flex-col items-stretch justify-start overflow-hidden p-3">
                            <p className="text-lg font-medium text-gray-900">One Line Overview</p>
                            <p className="text-gray-900 text-base">Predictable Benefits is a white-labeled ICHRA platform so that brokers, agencies, FMOs, PEOs or TPAs can build ICHRA plans with integrated employee plan shopping and enrollment workflows.</p>
                        </div>
                        <div className="bg-gray-50 w-full border border-gray-200 rounded-2xl flex flex-col items-stretch justify-start overflow-hidden p-3">
                            <p className="text-lg font-medium text-gray-900">Two Sentence Overview</p>
                            <p className="text-gray-900 text-base">Predictable Benefits is a white-labeled ICHRA platform so that brokers, agencies, FMOs, PEOs or TPAs can build ICHRA plans with ease, control, flexibility and designed for ACA compliance. Features include a full employer portal, mobile-friendly employee plan shopping, carrier enrollment workflows and payments integration.</p>
                        </div>
                        <div className="bg-gray-50 w-full border border-gray-200 rounded-2xl flex flex-col items-stretch justify-start overflow-hidden p-3">
                            <p className="text-lg font-medium text-gray-900">Three Sentence Overview</p>
                            <p className="text-gray-900 text-base">Predictable Benefits is a white-labeled ICHRA platform so that brokers, agencies, FMOs, PEOs or TPAs can build ICHRA plans with ease, control, flexibility and designed for ACA compliance. Predictable Benefits is not a broker, so all brokers retain their Broker of Record (AOR/BOR) relationship with both employers and employees. Features include a full employer portal, mobile-friendly employee plan shopping, carrier enrollment workflows and payments integration.</p>
                        </div>

                    </div>
                </div>

                <div className="flex flex-col gap-6 md:gap-8 lg:flex-row lg:items-start lg:gap-8">
                    <div className="flex w-full max-w-full flex-col gap-2 sm:max-w-md md:items-center md:text-center md:mx-auto md:max-w-none md:gap-4 lg:max-w-[300px] lg:shrink-0 lg:text-left lg:items-start">
                        <Elements.Title title="Sample Screens" type="h3" className="text-gray-900" />
                        <Elements.Description description="Download high-resolution product screenshots for press and promotional use." type="medium" className="text-gray-500" />
                    </div>

                    <div className="grid w-full flex-1 grid-cols-1 gap-3 sm:gap-4">
                        <div className="w-full overflow-hidden rounded-xl border border-gray-200 bg-[#F9FAFB] p-1.5 shadow-[inset_0px_0px_4px_0px_#0000001F] sm:rounded-2xl sm:p-2">
                            <div className="flex h-full flex-col rounded-xl bg-gray-50 p-3 shadow-[0px_0px_4px_0px_#00000014] sm:rounded-2xl sm:p-4">
                                <div className="relative w-full overflow-hidden rounded-lg sm:rounded-xl">
                                    <Image
                                        src={SampleScreen1}
                                        alt="Sample Screen 1"
                                        width={1000}
                                        height={500}
                                        className="h-[200px] w-full object-[70%_8%] object-cover sm:h-[280px] md:h-[340px] lg:h-[380px]"
                                    />
                                </div>

                                <div className="mt-3 flex w-full items-center justify-center sm:mt-4">
                                    <a
                                        href={OgImage}
                                        download="og-image.png"
                                        className="btn btn-primary btn-outline w-auto"
                                    >
                                        Download
                                    </a>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>



            </div>
        </section>
    );
};